// extracted by mini-css-extract-plugin
export default {"placeholder":"aM3LCb"};